import { FaInbox } from "react-icons/fa";
import styles from "./EmptyState.module.css";

const EmptyState = ({

    icon,

    title,

    description,

    buttonText,

    onClick,

}) => {

    return (

        <div className={styles.container}>

            <div className={styles.icon}>

                {

                    icon ?? <FaInbox />

                }

            </div>

            <h2>

                {title}

            </h2>

            {

                description &&

                <p>

                    {description}

                </p>

            }

            {

                buttonText &&

                <button

                    type="button"

                    onClick={onClick}

                >

                    {buttonText}

                </button>

            }

        </div>

    );

};

export default EmptyState;